import * as React from "react";
import type { SVGProps } from "react";
const SvgDelivery = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M9.02 16.582c0 1.446-1.185 2.618-2.648 2.618-1.462 0-2.648-1.172-2.648-2.618m5.297 0c0-1.446-1.186-2.618-2.649-2.618-1.462 0-2.648 1.172-2.648 2.618m5.297 0h5.958m-11.255 0H2.4V5.8a1 1 0 0 1 1-1h11.58v11.782m5.958 0c0 1.446-1.186 2.618-2.648 2.618s-2.649-1.172-2.649-2.618m5.297 0c0-1.446-1.186-2.618-2.648-2.618s-2.649 1.172-2.649 2.618m5.297 0h.662v-5.237l-3.31-3.272h-3.31v8.509m.661 0h-.662"
    />
  </svg>
);
export default SvgDelivery;
